module.exports = __webpack_public_path__ + "static/media/field-hockey.ddc2d251.svg";